import { OrganizationFeature } from '@trello/product-features';

export const isStandardOrg = (products: number[] = []) =>
  [115, 116, 117, 118].includes(products[0]);

export const isEnterpriseOrg = (premiumFeatures: string[] = []) => {
  return premiumFeatures.includes(OrganizationFeature.EnterpriseUI);
};
